import { Button, Flex } from "@chakra-ui/react";

// Annual / Quarterly pill toggle shared by the trend charts (main Emissions
// Trends + the detail-page 5-year trends). Same black-pill styling as the
// section's other toggles (Trend/Flow, compare-mode). Annual = one point per
// year; Quarterly = one point per quarter (Q1 2021 … Q4 2025) regardless of
// the page's quarter filter.
const OPTIONS = [
  { label: "Annual", value: false },
  { label: "Quarterly", value: true },
];

const QuartersSwitch = ({ isChecked, onChange }) => (
  <Flex bg="gray.100" borderRadius="full" p="3px">
    {OPTIONS.map((option) => {
      const active = isChecked === option.value;
      return (
        <Button
          key={option.label}
          size="xs"
          borderRadius="full"
          bg={active ? "pureBlack" : "transparent"}
          color={active ? "white" : "gray.500"}
          fontWeight={active ? "600" : "normal"}
          onClick={() => onChange(option.value)}
          _hover={{ bg: active ? "pureBlack" : "gray.200" }}
          px={3}
        >
          {option.label}
        </Button>
      );
    })}
  </Flex>
);

// "Q1 2021" … "Q4 2025" labels for a span of years, year-major order —
// matches the query order of the quarterly multi-year hooks.
export const quarterPeriodLabels = (years) =>
  years.flatMap((y) => ["Q1", "Q2", "Q3", "Q4"].map((q) => `${q} ${y}`));

export default QuartersSwitch;
